import { Component, OnInit, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Global } from 'src/app/core/resources/global';
import { File } from 'src/app/core/models/file';
import { map } from 'rxjs/operators';
import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/storage';
import { AccountService } from '../../account/account.service';
import { DocumentsService } from './documents.service';
import { Company } from 'src/app/core/interfaces/company';
import { NgxSpinnerService } from 'ngx-spinner';
import { User } from 'src/app/core/interfaces/user';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss'],
  providers: [AuthService, Global, AccountService, DocumentsService, AngularFireStorage]
})
export class DocumentsComponent implements OnInit {

  userActive: boolean = false;
  typeFiles: Array<Object> = [];
  basePath: string = '';
  company: Company;

  constructor(
    public authService: AuthService,
    private globalResources: Global,
    private accountService: AccountService,
    private angularFireStorage: AngularFireStorage,
    private documentsService: DocumentsService,
    private spinner: NgxSpinnerService) {
    this.userActive = this.authService && this.authService.userActive();
    this.typeFiles = this.globalResources.typeFiles;
    this.basePath = '/uploads/activation/administrator/' + this.authService.getUserSession().information.document + '/';
    this.company = this.authService && this.authService.getCompany();
  }

  ngOnInit() {

  }

  getDetailCompany(nit) {
    this.spinner.show();
    this.authService.getDetailCompany(nit).subscribe(
      (dataDetail) => {
        this.company = dataDetail;
        this.spinner.hide();
        if (this.company.companyId) {
          this.setFilesObjectCompany();
        }
      },
      (errorDetail) => {
        this.spinner.hide();
      }
    );
  }

  setFilesObjectCompany() {
    // if (this.company.rut) {
    //   this.typeFiles[0]['name'] = this.company.rut;
    //   this.typeFiles[0]['uploaded'] = true;
    //   this.typeFiles[0]['fileRegistered'] = true;
    // }

    // if (this.company.sheet0170) {
    //   this.typeFiles[1]['name'] = this.company.sheet0170;
    //   this.typeFiles[1]['uploaded'] = true;
    //   this.typeFiles[1]['fileRegistered'] = true;
    // }

    // if (this.company.qualityCertificateAndOther) {
    //   this.typeFiles[2]['name'] = this.company.qualityCertificateAndOther;
    //   this.typeFiles[2]['uploaded'] = true;
    //   this.typeFiles[2]['fileRegistered'] = true;
    // }

    // if (this.company.commercialReference) {
    //   this.typeFiles[3]['name'] = this.company.commercialReference;
    //   this.typeFiles[3]['uploaded'] = true;
    //   this.typeFiles[3]['fileRegistered'] = true;
    // }

    // if (this.company.balanceSheet) {
    //   this.typeFiles[4]['name'] = this.company.balanceSheet;
    //   this.typeFiles[4]['uploaded'] = true;
    //   this.typeFiles[4]['fileRegistered'] = true;
    // }

    // if (this.company.basicCertificate) {
    //   this.typeFiles[5]['name'] = this.company.basicCertificate;
    //   this.typeFiles[5]['uploaded'] = true;
    //   this.typeFiles[5]['fileRegistered'] = true;
    // }

    // if (this.company.bankReference) {
    //   this.typeFiles[6]['name'] = this.company.bankReference;
    //   this.typeFiles[6]['uploaded'] = true;
    //   this.typeFiles[6]['fileRegistered'] = true;
    // }

  }

  downloadFile(file: object) {
    if (file['name']) {
      let pathReference = this.angularFireStorage.ref(this.basePath + '/' + file['name']);
      pathReference.getDownloadURL().subscribe(
        (data) => {
          file['url'] = data;
          window.open(file['url']);
        },
        (error) => {
          file['url'] = '';
        }
      );
    }
  }


}
